import React, { useState } from 'react';
import logo from "../assets/images/logo.svg";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';


const MainHeader = () => {
  const UIDData = localStorage.getItem('uid');
  // const uid = atob(localStorage.getItem('uid'));
  console.log("uid" , UIDData)
  const [expanded, setExpanded] = useState(false);
  const [loginModalshow, setLoginModalshow] = useState(false);
  const navigate = useNavigate();

  const handleScrollToSection = (path, sectionId) => {
    navigate(path);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = window.innerWidth <= 768 ? 380 : 100;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 100);
    setExpanded(false); 
  };
  const loginmodalpen = () => {
    setLoginModalshow(true);
    setExpanded(false); 
    document.body.style.overflow = 'hidden';
  };
    const logOut = () => {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
      window.location.reload();
  }
  return (
    <>
      {/* sticky="top" */}
      <Navbar variant="light"  expand="lg" sticky='top' className='Headermain' expanded={expanded}>
        <Container fluid>
          <Navbar.Brand as={Link} to="/" >
            <img src={logo} alt="Logo" width={"160px"} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(expanded ? false : true)} />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto mainmenu bg-white navbar-nav p-2 rounded-3">
              <Nav.Link onClick={() => handleScrollToSection("/", "about")}>About us</Nav.Link>
              <Nav.Link onClick={() => handleScrollToSection("/", "WhatWeoffer")}>What We offer?</Nav.Link>
              <Nav.Link onClick={() => handleScrollToSection("/", "TypesofCars")}>Types of Cars</Nav.Link>
              <Nav.Link onClick={() => handleScrollToSection("/", "CarDetails")}>Car Details</Nav.Link>
              <Nav.Link onClick={() => handleScrollToSection("/", "WhereweOperate")}>Where we Operate</Nav.Link>
              <Nav.Link onClick={() => handleScrollToSection("/", "Reviews")} >Reviews</Nav.Link>
              <Nav.Link onClick={() => handleScrollToSection("/", "contact")} >Contact</Nav.Link>
            </Nav>
            <Nav className='d-flex mainmenu ms-3'>
            <Nav.Link as={Link} onClick={loginmodalpen} className='menu-btn'>Rent a Car</Nav.Link>
            {!UIDData && <Nav.Link as={Link} onClick={loginmodalpen} className='menu-btn active'>Login</Nav.Link> }
           {UIDData && <><Nav.Link as={Link} to="/profile" className='menu-btn active'><i className="bi bi-person-fill  me-1"></i> Profile</Nav.Link><Nav.Link as={Link} onClick={logOut} className='menu-btn active'><i className="bi bi-power"></i> Logout</Nav.Link>
           
           </>}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <LoginModal setLoginModalshow={setLoginModalshow} loginModalshow={loginModalshow} />
    </>
  );
}

export default MainHeader;
